import updateUserConfiguration from 'owa-session-store/lib/services/updateUserConfiguration';
import userConfigurationDictionaryEntry from 'owa-service/lib/factory/userConfigurationDictionaryEntry';
import userConfigurationDictionaryObject from 'owa-service/lib/factory/userConfigurationDictionaryObject';
import { getUserConfiguration } from 'owa-session-store';

export default async function saveBlockContentFromUnknownSendersService() {
    // Read from userConfig
    const userConfiguration = getUserConfiguration();
    updateUserConfiguration('Safety.UserOptions', [
        userConfigurationDictionaryEntry({
            DictionaryKey: userConfigurationDictionaryObject({
                Type: 'String',
                Value: ['BlockContentFromUnknownSenders'],
            }),
            DictionaryValue: userConfigurationDictionaryObject({
                Type: 'Boolean',
                Value: [String(userConfiguration.SafetyUserOptions.BlockContentFromUnknownSenders)],
            }),
        }),
    ]);
}
